import React, { useCallback, useState } from 'react'
import { useParams, useNavigate, NavigateFunction } from 'react-router-dom'

import { AppLayout, FormWrapper, LanguageSelector } from '@/components'
import { editCarPath, generatePath } from '@/utils'
import { IDriver } from '@/types'
import { t } from '@/i18n'

import Form from './form'
import { useData } from './useData'

const EditDriver: React.FC = () => {
  const navigate: NavigateFunction = useNavigate()
  const { id = '', carId = '' } = useParams()
  const [isEditing, setIsEditing] = useState<boolean>(false)
  const { data, loading, submitting, onDelete, onSubmit } = useData({ id })

  const onSubmitForm = useCallback(
    (d: IDriver) => {
      onSubmit(`cars/${carId}/driver/`, true, () => {
        setIsEditing(false)
        navigate(generatePath(editCarPath, { id: carId }))
      })({
        driver: { ...d, id },
      })
    },
    [carId, id, navigate, onSubmit],
  )

  return (
    <AppLayout
      hasFooter
      headerRight={
        <div className="app-right-container">
          <LanguageSelector />
        </div>
      }
    >
      <FormWrapper
        breadcrumbs={[{ name: isEditing ? 'edit_driver' : 'view_driver' }]}
        loading={loading || submitting}
        isEditing={isEditing}
        onEdit={() => setIsEditing(true)}
        onDelete={() => onDelete(id)}
      >
        <div className="content-box">
          <div className="scroll-wrap">
            <div className="content-title">
              <h2>
                {isEditing
                  ? t('edit_driver_label', { label: data.id })
                  : t('view_driver')}
              </h2>
            </div>
            <Form
              isEditing={isEditing}
              initialData={data}
              loading={loading}
              submitting={submitting}
              onCancel={() => setIsEditing(false)}
              onSubmit={onSubmitForm}
            />
          </div>
        </div>
      </FormWrapper>
    </AppLayout>
  )
}

export default EditDriver
